module.exports = __webpack_public_path__ + "images/emoji/flushed.4f8d0f9183d9b67a6e05.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/flushed.png
// module id = 1OIi
// module chunks = 13